'use client';

import { useState } from 'react';
import { DMImage } from '@/components/custom-image/custom-image';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';
import { signIn } from 'next-auth/react';

type SocialAuthButtonProps = {
  authType: string;
  icon: string;
  label: string;
};

function SocialAuthButton({ authType, icon, label }: SocialAuthButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = async () => {
    setIsLoading(true);
    try {
      await signIn(authType);
    } catch (error) {
      console.error('Sign in error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      onClick={!isLoading ? handleSignIn : undefined}
      className={cn(
        'bg-brand-secondary p-3 px-5 cursor-pointer hover:opacity-80 rounded-lg flex items-center text-center justify-center relative gap-3',
        {
          'opacity-50 cursor-not-allowed': isLoading,
        }
      )}
    >
      {isLoading ? (
        <Loader2 className='animate-spin' size={22} />
      ) : (
        <DMImage src={icon} width={30} height={30} alt={`${authType} icon`} />
      )}
      <span className='text-sm font-medium'>{label}</span>
    </div>
  );
}

export default SocialAuthButton;
